// extracted by mini-css-extract-plugin
export default {"portfolio_menu_option":"styles_portfolio_menu_option__1w9oS"};